export default __webpack_public_path__ + "static/rpa_01-7e524dbcdb1f1f4047281a270413af04.png";